import { useState, useEffect, useContext, useCallback, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { basePath, currentDateAndTime, formatDate, isObject, isValidDateTillCurrent, validateFile, validateNumber, validatePhoneNumber } from '../Constants/constant';
import { AppContext } from '../ContextApi/ContextApi';
import Swal from 'sweetalert2';
import PageBanner from '../Usables/PageBanner';
import RefreshButton from '../Usables/RefreshButton';
import BasicButton, { DownloadButton } from '../Usables/Buttons';
import CloseModal from '../Usables/CloseModal';
import Loader from '../Usables/Loader';
import Pagination from '../Usables/Pagination';
import InputField from '../Usables/InputField';
import Dropdown from '../Usables/Dropdown';
import NoRecords from '../Usables/NoRecords';
import "react-toastify/dist/ReactToastify.css";
import { UpDownArrow } from '../Usables/IconButtons';
import EditCandidate from '../Usables/EditCandidate';
import CompanyInfo from '../Usables/CompnayInfo';
import PositionWiseData from '../Usables/PositionWiseData';
import { useParams } from 'react-router-dom';

function ScreenedCandidate(props) {
    const { index } = useParams();
    const { apiHeaderFile, apiHeaderJSON, user } = useContext(AppContext);
    const [allCandidates, setAllCandidates] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [usersOption, setUsersOption] = useState([]);
    const [viewCandidate, setViewCandidate] = useState(false);
    const [viewCompany, setViewCompany] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [status, setStatus] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loading, setLoading] = useState("1");
    const [candidateEdit, setCandidateEdit] = useState(false);
    const [updateCandidateStatus, setUpdateCandidateStatus] = useState(false);
    const [errors, setErrors] = useState({});
    const [positionWiseView, setPositionWiseView] = useState(false);
    const [positionWiseData, setPositionWiseData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [formData, setFormData] = useState({});
    const [filterData, setFilterData] = useState({
        fromDate: "", toDate: "",
        company: "", position: "",
        candidate: "", recruiter: "",
        sourcingStatus: "", isActive: true,
        orderBy: "sourcing_date", orderDirection: "DESC"
    });
    const [positionFilter, setPositionFilter] = useState({
        fromDate: "", toDate: "",
        company: "", position: "",
        isActive: true, recruiter: "",
        orderBy: "upload_date", orderDirection: "DESC"
    });
    const [ischanged, setIschanged] = useState({
        positionListChanged: false,
        getListChanged: false,
    });
    const [pagination, setPagination] = useState({
        page: 1,
        totalRecords: "",
        totalPages: "",
        limit: 10,
    });
    const [paginationPositionList, setPaginationPositionList] = useState({
        page: 1,
        totalRecords: "",
        totalPages: "",
        limit: 10,
    });

    const statusOptions = [
        {value: "Screened", label: "Screened", disable: true, },
        {value: "Confirmation Pending", label: "Confirmation Pending", },
        {value: "Sent To Client", label: "Sent To Client", },
    ];
    const statusFilterOptions = [
        {value: "Screened", label: "Screened", },
        {value: "Confirmation Pending", label: "Confirmation Pending", },
        {value: "Rejected", label: "Rejected", },
    ];

    const getList = useCallback(async()=> {
        try {
            // console.log(" filterData",filterData?.candidate);
            const options = {
                params: {
                    limit: pagination?.limit,
                    page: pagination?.page,
                    filter: JSON.stringify(filterData),
                },
                headers: apiHeaderJSON
            }
            // const res = await axios.get(`${basePath}/getscreenedcandidatepagination?limit=${pagination?.limit}&page=${pagination?.page}&filter=${JSON.stringify(filterData)}`);
            const res = await axios.get(`${basePath}/getscreenedcandidatepagination`,options);
            setAllCandidates(res.data.candidates);
            setPagination({
                ...pagination,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.log(error);
        }
    },[apiHeaderJSON, filterData, pagination.limit, pagination.page]);
    // sorting screened candidate list data
    const handleScreenedSort = (columnName) => {
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, getListChanged: true });
    }

    const getPositionWiseData = useCallback(async()=> {
        try {
            setLoading(true);
            const res = await axios.get(`${basePath}/getpositionwisescreenedcandidatecount?limit=${paginationPositionList?.limit}&page=${paginationPositionList?.page}&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(positionFilter)}`);
            // console.log("+++++>>>>>res.data", res.data);
            const temp = res.data?.report?.filter((val) => {if (val?.candidate_count) { return val; }});
            // console.log("+++++>>>>>res.data", temp);
            setPositionWiseData(temp);
            setPaginationPositionList({
                ...paginationPositionList,
                totalPages: res?.data?.pages,
                totalRecords: res?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
        // setRowData(sent);
    },[paginationPositionList, positionFilter])
    const getUserData = async () => {
         let options = {
            headers:apiHeaderJSON
        }
        let response = await axios.get(`${basePath}/getRecruiter`, options);
        // console.log(response.data);
        const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        const listFilter = response?.data?.filter((val)=>{
            if(val?.activated === 1) return  val;
        });
        const activeList = listFilter?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
        });
        setAllUsers(recruiterList);
        setUsersOption(activeList);
    }

    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

             const options = {
                params: {
                    download:'yes',
                    filter: JSON.stringify(filterData),
                    page:pagination.page,
                    limit:pagination.limit
                },
                headers: apiHeaderJSON,
                responseType: 'blob',
            }
            const response = await axios.get(`${basePath}/getscreenedcandidatepagination`, options);

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Screened Candidates ${formatDate(currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            setLoadingFilter(false);
            toast.success("Excel Exported Successfully!");
        } catch (error) {
            console.error('Error exporting jobs:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
            setLoadingFilter(false);
        }
    };

    const ExportCandidateMapping = async () => {
        try {
            setLoadingFilter("3");
            Swal.fire({
                title: 'Please wait...',
                html: 'Your file is being prepared for download.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            let from_data = {
                candidate_list: selectedRows
            };
            const response = await axios.post(`${basePath}/getCanidateMappingForm`, from_data, {
                responseType: 'blob',  
                headers:apiHeaderJSON
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Candidates Mapping ${formatDate(currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            Swal.close();
            setLoadingFilter(false);
            setSelectedRows([]);
            toast.success("Candidate Mapping Exported Successfully!");
        } catch (error) {
           console.error('Error exporting candidate mapping:', error);
            let errorMsg = "There was a problem with the download";

            if (error.response && error.response.data) {
                const blob = error.response.data;

                try {
                    // Read the blob as text (usually contains JSON string)
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const json = JSON.parse(reader.result);
                            errorMsg = json?.error || json?.message || errorMsg;
                        } catch (e) {
                            console.warn("Could not parse error response:", e);
                            errorMsg = "Something went wrong while processing the error.";
                        }
                        toast.error(errorMsg);
                        Swal.close();
                        setLoadingFilter(false);
                    };
                    reader.readAsText(blob);
                } catch (e) {
                    toast.error("Unable to read error response.");
                    Swal.close();
                    setLoadingFilter(false);
                }

            } else {
                // Network error or no response
                toast.error(error.message || errorMsg);
                Swal.close();
                setLoadingFilter(false);
            }
            Swal.close();
        }
    };
    // sorting position wise list data
    const handleSort = (columnName) => {
        if (positionFilter?.orderBy === columnName) {
            if (positionFilter?.orderDirection === "DESC") {
                setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setPositionFilter({ ...positionFilter, orderBy: columnName, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, positionListChanged: true });
    }
    const handleDownload = async (canId = false, candidateName = "") => {
        setLoadingDownload(canId);
        const id = formData?.id || canId;
        try {
            const response = await fetch(`${basePath}/downloadresume/${id}`,{
                headers:apiHeaderJSON
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${candidateName.replace(/ /g, "_") || formData?.candidate.replace(/ /g, "_")}_resume_${formatDate(new Date())}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url); // Cleanup the URL object
            setLoadingDownload(false);
        } catch (error) {
            console.error('There was a problem with the download:', error);
            if (error?.status === 404) {
                toast.error(error?.response?.error);
            }
            else {
                toast.error("There was a problem with the download");
            }
            setLoadingDownload(false);
        }
    }
    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged?.getListChanged]);

    useEffect(() => {
        if(ischanged?.positionListChanged){
            // console.log("in getPositionWiseData");
            getPositionWiseData();
            setIschanged({ ...ischanged, positionListChanged: false })
        }
    }, [ischanged?.positionListChanged]);

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList() 
    },[getList]);

    useEffect(() => {
        getUserData();
        getList();
    }, []);

    // updating candidate current application status
    const handleStatus = async (e, row) => {
        const {value} = e.target;
        // console.log("row",row);
        Swal.fire({
        title: 'Are you sure?',
        text: `You want to change status to ${value || status}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Change!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
            const data = {
                candidate_id: row?.id || selectedRows,
                sourcing_status: value || status,
                recruiter_id: localStorage.getItem("userId"),
                type: selectedRows?.length > 0 ? "bulk" : "",
            }
            const options = {
                headers: { ...apiHeaderJSON },
            }
            setLoading("3");
            axios.patch(`${basePath}/statuschange`, data, options)
            .then((response) => {
                if (response.status == 200) {
                    // console.log(response);
                    getList();
                    toast.success(response?.data?.message || "Candidate Status Updated Successfully");
                    setStatus(false);
                    handleClose();
                }
                else {
                    setIsUpdate(true);
                    toast.error(response?.data?.message || "Opps!! Something went wrong.");
                }
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setIsUpdate(true);
                toast.error( e.response?.data?.message || "Internal server error!");
            });
        }
        else{
            setStatus("");
        }})
    }

    // updating candidate personal details
    const handleCandidateSubmit = () => {
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        // console.log("handleCandidateSubmit => formData =>",formData);
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to save!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Save!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30', 
            cancelButtonColor: '#F44336',
            allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
            setLoadingUpdate(true);
            const data = {
                ...formData,
                candidate_resume: null,
                candidate_question_answers: JSON.stringify(formData?.position_questions),
                recruiter_id: localStorage.getItem("userId"),
            }
            if(isObject(formData?.candidate_resume)){
                data.candidate_resume = formData?.candidate_resume;
            }
            // console.log("=========:>>>>>> ", data);
            const options = {
                headers: {...apiHeaderFile},
            }
            axios.patch(`${basePath}/editatspipeline/${viewCandidate?.id}`,data, options)
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response);
                    handleClose();
                    getList();
                    setLoadingUpdate(false);
                    toast.success( response?.data?.message || "Updated Successfully");
                    // console.log("Information entered successfully");
                    // if(!response?.data?.candidate?.candidate_resume) || viewCandidate?.?.candidate_resume){
                    //     toast.error("Candidate Resume Unable To Update!!");
                    // }
                }
                else {
                    setLoadingUpdate(false);
                    toast.error(response?.data?.message || "Opps!! Something went wrong.");
                }
            })
            .catch((e) => {
                setLoadingUpdate(false);
                console.log(e);
                toast.error(e.response?.data?.message || "Internal server error!");
            });
        }})
    }

    const validateForm = ()=>{
            const errors = {};
            if (!formData?.candidate || formData?.candidate.trim() === "") {
                errors.candidate = "Candidate name is required!";
                return errors;
            } else if (formData?.candidate.length < 3) {
                errors.candidate = "Name must be at least 3 characters!";
                return errors;
            } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate)) {
                errors.candidate = "Name can only contain letters!";
                return errors;
            }
            // Email validation
            if (!formData?.candidate_email || formData?.candidate_email.trim() === "") {
                errors.candidate_email = "Email is required!";
                return errors;
            } else if (
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.candidate_email)
            ) {
                errors.candidate_email = "Invalid email address!";
                return errors;
            }
    
            // mobile number validation
            if (!formData?.phone_code || formData?.phone_code.trim() === "") {
                errors.phone_code = "Required!";
                return errors;
            }
            if (!formData?.candidate_phone || formData?.candidate_phone.trim() === "") {
                errors.candidate_phone = "Mobile number is required!";
            } else if (formData?.phone_code && formData?.candidate_phone) {
                const validateNum = validatePhoneNumber(formData?.phone_code, formData?.candidate_phone);
                if(!validateNum?.isValid && validateNum?.codeError) {
                    errors.phone_code = validateNum?.message;
                    return errors;
                }
                else if(!validateNum?.isValid && !validateNum?.codeError) {
                    errors.candidate_phone = validateNum?.message;
                    return errors;
                }
            }
            
            if ((!formData?.phone_alt_code || formData?.phone_alt_code.trim() === "") && formData?.candidate_alt_phone) {
                errors.phone_alt_code = "Required!";
                return errors;
            }
            // if (!formData?.candidate_alt_phone || formData?.candidate_alt_phone.trim() === "") {
            //     errors.candidate_alt_phone = "Mobile number is required!";
            // }
            if (formData?.phone_alt_code && formData?.candidate_alt_phone) {
                const validateNum = validatePhoneNumber(formData?.phone_alt_code, formData?.candidate_alt_phone);
                if(!validateNum?.isValid && validateNum?.codeError) {
                    errors.phone_alt_code = validateNum?.message;
                    return errors;
                } else if(!validateNum?.isValid && !validateNum?.codeError) {
                    errors.candidate_alt_phone = validateNum?.message;
                    return errors;
                }
            }
    
            if (!formData?.candidate_location || formData?.candidate_location.trim() === "") {
                errors.candidate_location = "Candidate location is required!";
                return errors;
            } else if (!/^[A-Za-z\s]+$/.test(formData?.candidate_location)) {
                errors.candidate_location = "Location can only contain letters!";
                return errors;
            }
            if (!formData?.candidate_qualification || formData?.candidate_qualification.trim() === "") {
                errors.candidate_qualification = "Qualification is required!";
                return errors;
            }
            if (!formData?.current_currency_code) {
                errors.current_currency_code = "Required!";
                return errors;
            }
            if (!formData?.candidate_current_ctc || formData?.candidate_current_ctc.trim() === "") {
                errors.candidate_current_ctc = "Current CTC is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_current_ctc, 100000000)?.success) {
                errors.candidate_current_ctc = validateNumber(formData?.candidate_current_ctc, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_ectc_type) {
                errors.candidate_ectc_type = "Required!";
                return errors;
            }
            if (!formData?.expected_currency_code) {
                errors.expected_currency_code = "Required!";
                return errors;
            }
            if (!formData?.candidate_expected_ctc || formData?.candidate_expected_ctc.trim() === "") {
                errors.candidate_expected_ctc = "Expected CTC is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_expected_ctc, 100000000)?.success) {
                errors.candidate_expected_ctc = validateNumber(formData?.candidate_expected_ctc, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_industry || formData?.candidate_industry.trim() === "") {
                errors.candidate_industry = "Industry is required!";
                return errors;
            }
            if (!formData?.candidate_experience || formData?.candidate_experience.trim() === "") {
                errors.candidate_experience = "Experience is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_experience, 50)?.success) {
                errors.candidate_experience = validateNumber(formData?.candidate_experience, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_notice_period) {
                errors.candidate_notice_period = "This field is required!";
                return errors;
            } else if (!validateNumber(formData?.candidate_notice_period, 500)?.success) {
                errors.candidate_notice_period = validateNumber(formData?.candidate_notice_period, 500)?.message;
                return errors;
            }
            if (!formData?.candidate_gender || formData?.candidate_gender.trim() === "") {
                errors.candidate_gender = "This field is required!";
                return errors;
            }
            if (formData?.candidate_dob && !isValidDateTillCurrent(formData?.candidate_dob)) {
                errors.candidate_dob = "DOB should be less or equal to current year!";
                return errors;
            }
            if (formData?.candidate_resume && isObject(formData?.candidate_resume)){
                const valid = validateFile(formData?.candidate_resume, 5, ['application/pdf']);
                if (!valid?.valid) {
                    errors.candidate_resume = valid?.message;
                    return errors;
                }
            }      
            if( Array.isArray(formData.position_questions) && !validateMandatory()){
                errors.required = "Required!";
                return errors;
            }
        return errors;
    }
    
    // valiadte that is any questions answer is empty or not  
    const validateMandatory = () => {
        let isValid = true;

        const updatedQuestions = formData.position_questions.map(item => {
        if (item.is_mandatory === 1 && (!item.response_text || item.response_text.trim() === "")) {
            isValid = false;
            return { ...item, error_text: "This question is mandatory." };
        }
        return { ...item, error_text: "" };
        });

        setFormData(prev => ({
        ...prev,
        position_questions: updatedQuestions
        }));

        return isValid;
    };
    

    // handling edit button 
    const handleEdit = (val) => {
        // console.log("edit val =>", val);
        setFormData({
            id: val?.id,
            candidate: val?.candidate || "",
            candidate_email: val?.candidate_email || "",
            phone_code: val?.phone_code || "",
            candidate_phone: val?.candidate_phone || "",
            phone_alt_code: val?.phone_alt_code || "",
            candidate_alt_phone: val?.candidate_alt_phone || "",
            candidate_location: val?.candidate_location || "",
            candidate_qualification: val?.candidate_qualification || "",
            current_currency_code: val?.current_currency_code || "",
            candidate_current_ctc: val?.candidate_current_ctc || "",
            candidate_ectc_type: val?.candidate_ectc_type || "",
            expected_currency_code: val?.expected_currency_code || "",
            candidate_expected_ctc: val?.candidate_expected_ctc || "",
            candidate_dob: val?.candidate_dob || "",
            candidate_industry: val?.candidate_industry || "",
            candidate_organization: val?.candidate_organization || "",
            candidate_designation: val?.candidate_designation || "",
            candidate_experience: val?.candidate_experience || "",
            candidate_notice_period: val?.candidate_notice_period || "",
            candidate_gender: val?.candidate_gender || "",
            candidate_resume: val?.resume_link || "",
            position_questions: val?.CandidateQnAs || [],
            candidate_remarks: val?.candidate_remarks 
        });
        // setCandidateEdit(true);
        setViewCandidate(val)
    }
    const handleCancelEdit = () => {
        // console.log("edit val =>", viewCandidate);
        // console.log("edit val 2 =>", viewCandidate?.candidate_phone?.split("-")[0]);
        setFormData({
            id: viewCandidate?.id,
            candidate: viewCandidate?.candidate || "",
            candidate_email: viewCandidate?.candidate_email || "",
            phone_code: viewCandidate?.phone_code || "",
            candidate_phone: viewCandidate?.candidate_phone || "",
            phone_alt_code: viewCandidate?.phone_alt_code || "",
            candidate_alt_phone: viewCandidate?.candidate_alt_phone || "",
            candidate_location: viewCandidate?.candidate_location || "",
            candidate_qualification: viewCandidate?.candidate_qualification || "",
            current_currency_code: viewCandidate?.current_currency_code || "",
            candidate_current_ctc: viewCandidate?.candidate_current_ctc || "",
            candidate_ectc_type: viewCandidate?.candidate_ectc_type || "",
            expected_currency_code: viewCandidate?.expected_currency_code || "",
            candidate_expected_ctc: viewCandidate?.candidate_expected_ctc || "",
            candidate_dob: viewCandidate?.candidate_dob || "",
            candidate_industry: viewCandidate?.candidate_industry || "",
            candidate_organization: viewCandidate?.candidate_organization || "",
            candidate_designation: viewCandidate?.candidate_designation || "",
            candidate_experience: viewCandidate?.candidate_experience || "",
            candidate_notice_period: viewCandidate?.candidate_notice_period || "",
            candidate_gender: viewCandidate?.candidate_gender || "",
            candidate_resume: viewCandidate?.candidate_resume || "",
            position_questions: viewCandidate?.CandidateQnAs || [],
            candidate_remarks: viewCandidate?.candidate_remarks 
        });
        setViewCandidate(viewCandidate);
        setCandidateEdit(false);
    }
    const handleEditOn = ()=> {
        setCandidateEdit(true);
    }
    // used for debounce timer 
    const debounceTimerRef = useRef(null);
    const debounceGetList = (delay = 500)=> {
        // it will call getList after defined time (delay)
        if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            setIschanged({ ...ischanged, getListChanged: true })
        }, delay);
    }
    const debounceGetPositionWiseData = (delay = 500)=> {
        // it will call getList after defined time (delay)
        if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            setIschanged({ ...ischanged, positionListChanged: true })
        }, delay);
    }
    const handleChangePositionFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setPositionFilter({ ...positionFilter, [name]: value,});
        // it will call getList after defined time (delay)
        // debounceGetPositionWiseData();
    },[positionFilter,ischanged]);

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceGetList();        
    },[filterData]);
    
    // candidate details form input handle function
    const handleChangeInput = useCallback((event,id)=> {
        const {name, value} = event?.target;
        // console.log("name, value",name, value);
        if (name === "answer") {
        setFormData(prev => ({
            ...prev,
            position_questions: prev.position_questions.map(item =>
                item.question_id === id
                ? { ...item, response_text: value, error_text: "" }
                : item
            )}));
        } else if (name === "current_currency_code") {
        setFormData({ ...formData, [name]: value, expected_currency_code: value }); setErrors({...errors, [name]: "", expected_currency_code: ""});
        } else {setFormData({ ...formData, [name]: value, }); setErrors({...errors, [name]: ""});}
    },[formData]);

    const handleSelect = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log(name, value);
        setFilterData({ ...filterData, [name]: value });
        setErrors({ ...errors, [name]: "", }); 
        // it will call getList after defined time (delay)
        // debounceGetList(100);        
    },[filterData]);
    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{
            // console.log("val?.activated === e.target.value",idx + 1,"=>",val?.activated, num,val?.activated === num)
            if(val?.activated === num) return val;
        });
        setFilterData({ ...filterData, isActive: checked }); 
        // console.log("all",all);
        setUsersOption(all);
    },[allUsers, filterData]);
    const handlePositionCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val,idx)=>{
            // console.log("val?.activated === e.target.value",idx + 1,"=>",val?.activated, num,val?.activated === num)
            if(val?.activated === num) return val;
        });
        setPositionFilter({ ...positionFilter, isActive: checked }); 
        // console.log("all",all);
        setUsersOption(all);
    },[allUsers]);

    const handlePositionSelect = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log(name, value);
        setPositionFilter({ ...positionFilter, [name]: value });
        // it will call getList after defined time (delay)
        // debounceGetPositionWiseData(100);
    },[positionFilter,ischanged]);

    const handleRefresh = () => {
        // console.log("loading || loadingFilter",loading, loadingFilter)
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }
    const handleRefreshPosition = () => {
        setLoading("2");
        getPositionWiseData();
    }
    const handlePositionFilter = useCallback(() => {
        setLoadingFilter("3");
        getPositionWiseData();
    },[getPositionWiseData]);
    
    const handlePositionClear = useCallback(() => {
        setLoadingFilter("4");
        setPositionFilter({
            fromDate: "",
            toDate: "",
            company: "",
            position: "",
            orderBy: "upload_date",
            isActive: positionFilter?.isActive,
            recruiter: "",
            orderDirection: "DESC",
            status: ""
        });
        setFilterData({
            ...filterData,
            isActive: positionFilter?.isActive,
        });     
        setIschanged({...ischanged, positionListChanged: true, getListChanged:false})
    },[ischanged, filterData, positionFilter]);

    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        // console.log("filterData?.isActive",filterData?.isActive);
        setFilterData({
            fromDate: "",
            toDate: "",
            company: "",
            position: "",
            candidate: "",
            isActive: filterData?.isActive,
            recruiter: "",
            orderBy: "sourcing_date",
            orderDirection: "DESC"
        });
        setPositionFilter({
            fromDate: "",
            toDate: "",
            company: "",
            position: "",
            orderBy: "upload_date",
            isActive: filterData?.isActive,
            recruiter: "",
            orderDirection: "DESC",
            status: ""
        });
        
        setIschanged({...ischanged, positionListChanged:false, getListChanged:true})
    },[ischanged, filterData]);

    const handleClose = ()=> {
        // console.log("onClose out");
        setPositionWiseView(false);
        setPositionFilter({});
        setViewCandidate(false);
        setCandidateEdit(false);
        setViewCompany(false);
        setUpdateCandidateStatus(false);
        setSelectedRows([]);
        setFormData({});
        setStatus(false);
    }
    const handlePositionModal = ()=> {
        setLoading('2');
        getPositionWiseData(); 
        setPositionWiseView(true);
    }
    const handleLimitPositionList = (e)=> {
        setPaginationPositionList({...paginationPositionList, limit: e.target.value});
        setIschanged({...ischanged, positionListChanged: true})
    }
    const handlePrevPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.page > 1) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page - 1});
            setIschanged({...ischanged, positionListChanged: true})
        }
    }
    const handleNextPositionList = (e)=> {
        // console.log("paginationPositionList?.totalPages > paginationPositionList?.page",paginationPositionList?.totalPages, paginationPositionList?.page)
        if (paginationPositionList?.totalPages > paginationPositionList?.page) {
            setPaginationPositionList({...paginationPositionList, page: paginationPositionList?.page + 1});
            setIschanged({...ischanged, positionListChanged: true})
        }
    }
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(allCandidates.map((row) => {return {id: row?.id, candidate: row?.candidate,
                recruiter_name: row?.User?.name,
                company_name: row?.Position?.Company?.company_name,
                position_name: row?.Position?.position,
            }}));
        } else {
            setSelectedRows([]);
        }
    };
    const handleCheckboxChange = (candidateData) => {
        const isSelected = selectedRows.some((row) => row.id === candidateData?.id);
        if (isSelected) {
        setSelectedRows(selectedRows.filter((row) => row.id !== candidateData?.id));
        } else {
            setSelectedRows([...selectedRows,{id: candidateData?.id, candidate: candidateData?.candidate,
                recruiter_name: candidateData?.User?.name,
                company_name: candidateData?.Position?.Company?.company_name,
                position_name: candidateData?.Position?.position,
            },]);
        }
    };
    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true});
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    const handleNext = (e)=> {
        
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }
    // console.log("{user[index]?.edit_access}", user[index]?.edit_access);
    return (
        <section onClick={() => { }} className='lightBabyGreen baseHeightWidth customScroll mb-5'>
            {/* {!loading && (<LoadingBar/>)} */}
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <div>
            {/* PageBanner => used to show page banner info */}
            <PageBanner pageName='Screened Candidates' pageTitle='Ready to start your day' src='/img/registration.png' alt="screened candidate" />
                {viewCompany ? <CompanyInfo data={viewCompany} onClose={handleClose} /> : null}
                {viewCandidate ?
                    <div className=' w-full h-screen fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
                        <div className=' bg-white overflow-auto mx-10 mb-5 p-10 rounded-3xl candidateInfoBox'>
                            <EditCandidate 
                            onChange={handleChangeInput}
                            onCancel={handleCancelEdit}
                            onClose={handleClose}
                            onSubmit={handleCandidateSubmit}
                            OnlyView={!user[index]?.edit_access}
                            onEdit={handleEditOn}
                            data={formData}
                            onDownload={handleDownload}
                            loading={loadingUpdate}
                            errors={errors}
                            disabled={!candidateEdit}
                            />
                        </div>
                    </div> : null
                }

                {/* show position wise details */}
                {positionWiseView &&
                    (<PositionWiseData rows={positionWiseData} usersOption={usersOption}
                    filter={positionFilter} pagination={paginationPositionList} loading={loading === "3"} loadingFilter={loadingFilter === "3"} loadingClear={loadingFilter === "4"}
                    onChangeFilter={handleChangePositionFilter} onClose={handleClose} onRefresh={handleRefreshPosition} onFilter={handlePositionFilter}
                    onFilterClear={handlePositionClear} onPositionCheck={handlePositionCheck} onPositionSelect={handlePositionSelect} onSort={handleSort} onLimit={handleLimitPositionList}
                    onPrev={handlePrevPositionList} onNext={handleNextPositionList}
                    />)
                }

                {updateCandidateStatus && (
                    <div className=' w-full h-screen  fixed left-0 top-0 z-20 flex items-start justify-center  blurBack'>
                        <div onClick={(e) => { e.stopPropagation(); }} className=' relative  w-[70%] bg-white rounded-2xl mx-10 mt-6 md:px-10 px-2 py-10   '>
                            <CloseModal disabled={loading === "3"}  onClick={handleClose} />
                            <div>
                                <div className="grid grid-cols-[3fr_1fr] gap-3 md:w-1/2">
                                    <Dropdown id="candidate_status" name="candidate_status" label="Candidate Status:"
                                        onChange={(e)=> setStatus(e.target.value)}
                                        onCancel={(e)=> setStatus(e.target.value)}
                                        className=" rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]"
                                        placeholder={`Select status`}
                                        value={status}
                                        disabled={ selectedRows?.length === 0 || loading === "3"} 
                                        options={statusOptions}
                                    />
                                    {user[index]?.edit_access && (
                                    <div>
                                        <label className="block  text-left font-medium text-white mb-1 text-nowrap">Update Status</label>
                                        <BasicButton onClick={handleStatus} buttonName='Update Status' className='darkPurple text-nowrap' shadow={true}
                                        disabled={ selectedRows?.length === 0 || loading === "3" || !status} 
                                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                                    </div>
                                    )}
                                </div>
                                <div className=' mt-2 overflow-auto border-b-2 border-gray-200 tableBody tableBox'>
                                    <table className='  rounded-xl baseWidth text-left'>
                                        <thead className='  tableHead'>
                                            <tr className=' bg-gray-200'>
                                                <th className=' w-7'>
                                                    <div className="flex gap-1 items-center justify-center">
                                                        Selected
                                                        <span className={`${selectedRows?.length > 0 ? "text-blue-700" : "text-gray-400"}`}>({selectedRows?.length > 0 ? selectedRows?.length : 0})</span>
                                                    </div>
                                                </th>
                                                {/* <th className='whitespace-nowrap text-center' >Sr.No.</th> */}
                                                <th className='whitespace-nowrap' >Candidate Name</th>
                                                <th className='whitespace-nowrap' >Recruiter</th>
                                                <th className='whitespace-nowrap' >Company Name</th>
                                                <th className='whitespace-nowrap' >Position Name</th>
                                            </tr>
                                        </thead>
                                        <tbody className='tableBody'>
                                            {selectedRows?.map((val, idx)=>{
                                                return (
                                                <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                     <td>
                                                        <div className="flex justify-center items-center">
                                                        <input type="checkbox"
                                                            className="form-check-input cursorPointer"
                                                            // disabled={loadingPayroll}
                                                            checked={selectedRows.some((item) => item.id === val?.id )}
                                                            onChange={() => handleCheckboxChange(val)}
                                                        />
                                                        </div>
                                                    </td>
                                                    {/* <td className=' text-center'>{idx + 1}</td> */}
                                                    <td >{val?.candidate}</td>
                                                    <td > <span className=' px-2 py-1 rounded-lg greenBox w-full whitespace-nowrap text-center'>{val?.recruiter_name}</span></td>
                                                    <td >{val?.company_name}</td>
                                                    <td >{val?.position_name}</td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {/* filters */}
                <div className=' grid lg:grid-cols-6 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                    <InputField  id="fromDate" name="fromDate" type="date" label="From:"
                    disabled={loading === '1'}
                    value={filterData?.fromDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To:"
                    disabled={loading === '1'}
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                    placeholder="Enter Candidate"
                    disabled={loading === '1'}
                    value={filterData?.candidate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="company" name="company" type="text" label="Company:"
                    placeholder="Enter Company"
                    disabled={loading === '1'}
                    value={filterData?.company}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="position" name="position" type="text" label="Position:"
                    placeholder="Enter Position"
                    disabled={loading === '1'}
                    value={filterData?.position}
                    onChange={handleChangeFilter}
                    />
                    <Dropdown id="sourcingStatus" name="sourcingStatus" label="Sourcing Status:"
                        onChange={handleSelect}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`All`}
                        value={filterData?.sourcingStatus}
                        options={statusFilterOptions}
                    />
                    <Dropdown id="recruiter" name="recruiter" label="Recruiter:"
                        onChange={handleSelect}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiter}
                        options={usersOption}
                        search={true} // to enable search input
                        checkBox={true} // to enable checkbox
                        checkValue={filterData?.isActive} // to make checkbox check and uncheck
                        onCheck={handleCheck} // to make changes in list of options onChange  
                    />
                    <div className="flex gap-3 col-span-1">
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                        <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiter && !filterData?.sourcingStatus)} 
                        loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                        <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.candidate && !filterData?.company && !filterData?.position && !filterData?.recruiter && !filterData?.sourcingStatus)} 
                        loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                        <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                        disabled={loading || loadingFilter } 
                        loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                    </div>
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Position Details</label>
                        <BasicButton onClick={handlePositionModal} buttonName='Position Details' className="bg-purple-700 text-nowrap" shadow={true}
                        disabled={loading} 
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-purple-900" />
                    </div>
                    {(selectedRows?.length > 0 && user[index]?.edit_access) && (
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Update Status</label>
                        <BasicButton onClick={()=> setUpdateCandidateStatus(true) } buttonName='Update Status' className="bg-amber-600 text-nowrap" shadow={true}
                        disabled={loading} 
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-amber-700" />
                    </div>
                    )}
                    {selectedRows?.length > 0 && (
                    <div className=" flex flex-col">
                        <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Candidate Mapping</label>
                        <BasicButton onClick={()=> ExportCandidateMapping() } buttonName='Export Mapping' className="bg-green-600 text-nowrap" shadow={true}
                        disabled={loading} 
                        rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-700" />
                    </div>
                    )}
                    </div>
                    
                </div>
                {loading === "1" ?
                    <Loader/> :
                    Array.isArray(allCandidates) && allCandidates?.length >= 1 ?
                    <section className='tableWrapper'>
                        <div className=' tableBody'>
                            <table className='w-full table-fixed border-collapse'>
                                <thead className='tableHead'>
                                    <tr className=' text-left'>
                                        {Array.isArray(allCandidates) && allCandidates?.length > 0 && (
                                            <th className=' w-16'>
                                                <div className="flex gap-1 items-center justify-center">
                                                    <input type="checkbox" className="" 
                                                    checked={selectedRows?.length === allCandidates?.length && allCandidates?.length>0}
                                                    onChange={handleSelectAll}
                                                    />                                                    
                                                    <span className={`${selectedRows?.length > 0 ? "text-blue-700" : "text-gray-400"}`}>({selectedRows?.length > 0 ? selectedRows?.length : 0})</span>
                                                </div>
                                            </th>)}
                                        <th className='whitespace-nowrap w-48'  >
                                            <div onClick={() => handleScreenedSort("sourcing_date")} className='flex item-center gap-2 justify-start w-full cursor-pointer'>
                                                Sourced Date
                                                {filterData?.orderBy === "sourcing_date" && filterData?.orderDirection === "ASC" ?
                                                    <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                    filterData?.orderBy === "sourcing_date" && filterData?.orderDirection === "DESC" ?
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>
                                        </th>
                                        <th className='whitespace-nowrap pr-6'>
                                            <div onClick={() => handleScreenedSort("candidate")} className='flex item-center justify-start gap-2 w-full cursor-pointer'>
                                                Candidate
                                                {filterData?.orderBy === "candidate" && filterData?.orderDirection === "ASC" ?
                                                    <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                    filterData?.orderBy === "candidate" && filterData?.orderDirection === "DESC" ?
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>
                                        </th>
                                        <th className='whitespace-nowrap' >
                                            <div onClick={() => handleScreenedSort("position")} className='flex item-center gap-2 w-full cursor-pointer'>
                                                Position
                                                {filterData?.orderBy === "position" && filterData?.orderDirection === "ASC" ?
                                                    <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                    filterData?.orderBy === "position" && filterData?.orderDirection === "DESC" ?
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                    <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                            </div>
                                        </th>
                                        <th className='whitespace-nowrap text-center w-24'>Resume</th>
                                        <th className='whitespace-nowrap text-center'>Candidate Status</th>
                                    </tr>
                                </thead>
                                <tbody className='tableBody'>
                                    {
                                        Array.isArray(allCandidates) && allCandidates?.map((val, idx) => {
                                            return (
                                                <tr key={val?.id} id={val?.id} className='font-semibold text-sm text-left'>
                                                    <td>
                                                        <div className="flex justify-center items-center">
                                                        <input type="checkbox"
                                                            className="form-check-input cursorPointer"
                                                            // disabled={loadingPayroll}
                                                            checked={selectedRows.some((item) => item.id === val?.id )}
                                                            onChange={() => handleCheckboxChange(val)}
                                                        />
                                                        </div>
                                                    </td>
                                                    <td className=' whitespace-nowrap text-left'>
                                                        <span className='line-clamp-1 text-ellipsis'>{val?.sourcing_date ? formatDate(val?.sourcing_date) : "--"}</span>
                                                        {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? null : 
                                                        (<span className={`line-clamp-1 text-ellipsis ${val?.sourcing_status === 'Confirmation Pending' ? `text-yellow-600`: val?.sourcing_status === 'Rejected' ? `text-red-700` : `text-green-600`}`}
                                                        >{val?.User?.name}</span>)}
                                                    </td>
                                                    <td className=' whitespace-nowrap'>
                                                        <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.candidate && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (val?.candidate && (user[index]?.view_access || user[index]?.edit_access)) handleEdit(val)}}>{val?.candidate || "--"}</span>
                                                        <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.candidate_email ? val?.candidate_email : "NA"}</span>
                                                    </td>
                                                    
                                                    <td className=' whitespace-nowrap'>
                                                        <span className={` line-clamp-1 text-ellipsis text-blue-900 ${val?.Position?.Company.company_name && user[index]?.view_access && "hover:text-blue-600 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={(e) => {if (val?.Position?.Company.company_name && user[index]?.view_access) setViewCompany(val); }}>{val?.Position?.Company.company_name}</span>
                                                        <span className='text-sm line-clamp-1 text-ellipsis' >{val?.Position?.position}</span>
                                                    </td>
                                                    <td className=' text-center'>
                                                       <DownloadButton data={val} onClick={()=> handleDownload(val?.id, val?.candidate)} tooltipName="Download Resume" disabled={!val?.resume_link || loadingDownload === val?.id} />
                                                    </td>
                                                    <td className=' text-center'>
                                                        <Dropdown id="candidate_status" name="candidate_status"
                                                            onChange={(e)=> handleStatus(e, val)}
                                                            onCancel={handleSelect}
                                                            className={`rounded border border-gray-300 w-full flex-1 text-[0.8rem] m-auto`}
                                                            placeholder={val?.sourcing_status === "Rejected" ? "Rejected" : `Select status`}
                                                            width='w-[14rem]'
                                                            closeBtn={false}
                                                            disabled={val?.sourcing_status === "Rejected" || !user[index]?.edit_access}
                                                            value={status && isUpdate === val?.id ? status : val?.sourcing_status}
                                                            options={statusOptions}
                                                        />
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                        limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                        disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                        />
                    </section> :
                    <NoRecords />
                }
            </div>
        </section>
    );
}

export default ScreenedCandidate;